module.exports = __webpack_public_path__ + "a5cb5e63a281c9defd87294241177249.svg";